import React, { useEffect } from 'react'
import BasicToast from './components/common/BasicToast'
import { useAppDispatch, useAppSelector } from './redux/hooks'
import Layout from './components/layout/Layout'
import { VIEW } from './constant'
import Listing from './components/property/Listing'
import ListingDetail from './components/property/ListingDetail'
import SelectDates from './components/property/SelectDates'
import SelectGuest from './components/property/SelectGuest'
import { setView } from './redux/slices/common'
import { setRatesBaseOnUsd, setRateObjBaseOnUsd } from './redux/slices/property'
import { getRateCurrency } from './api/common'
import SelectPayments from './components/property/SelectPayments'
import BookingSuccessed from './components/property/BookingSuccessed'

interface Props {
  hostId?: string
  propertyId?: string
}

// propertyId: id host send via script
// listingId: id user select via UI
const App: React.FC<Props> = ({ hostId, propertyId }) => {
  const dispatch = useAppDispatch()
  const { view } = useAppSelector((state) => state.common)
  const { listingData } = useAppSelector((state) => state.property)

  useEffect(() => {
    async function fetchRateCurrency() {
      const res = await getRateCurrency()
      if (Array.isArray(res.data)) {
        dispatch(setRatesBaseOnUsd(res.data))
        const rateObj: any = {}
        for (let item of res.data) {
          rateObj[item.key] = item
        }
        dispatch(setRateObjBaseOnUsd(rateObj))
      }
    }

    fetchRateCurrency()
  }, [])

  const updateView = (view: string) => {
    dispatch(setView(view))
  }

  if (!hostId) {
    return null
  }

  return (
    <div className="dtravel-sdk">
      <Layout updateView={updateView}>
        <div className={'dtravel-inter-500 dtravel-text-14-18 dtravel-neutral-800'}>
          {view === VIEW.LIST && <Listing hostId={hostId} propertyId={propertyId} updateView={updateView} />}
          {view === VIEW.DETAIL && <ListingDetail hostId={hostId} updateView={updateView} />}
          {view === VIEW.SELECT_DATES && (
            <SelectDates
              hostId={hostId}
              listingId={listingData?.id}
              updateView={updateView}
              propertyCurrency={listingData?.propertyPrice?.currency}
            />
          )}
          {view === VIEW.SELECT_GUEST && (
            <SelectGuest
              personCapacity={listingData.personCapacity}
              maxPet={listingData.maxPet}
              updateView={updateView}
            />
          )}
          {view === VIEW.SELECT_PAYMENT && <SelectPayments hostId={hostId} updateView={updateView} />}
          {view === VIEW.BOOKING_SUCCESSED && <BookingSuccessed hostId={hostId} updateView={updateView} />}

          {/*{isListingNotFound && <p className={'dtravel-text-center text-red-700 text-24-29 mt-4'}>Property not found</p>}*/}
          {/*{listingData && <Checkout hostId={hostId} listingData={listingData} />}*/}
        </div>

        <BasicToast />
      </Layout>
    </div>
  )
}

export default App
